import "./src/styles/global.css";

import { trackPageView } from "./src/lib/analytics-client";

export const onRouteUpdate = ({ location }) => {
  window.setTimeout(() => {
    trackPageView(location);
  }, 0);
};
